import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { Parameter, FundParameters, PeriodTypeEnum, Employee, Income } from '@akiba/models_bimbo';
import { environment } from 'projects/bimbo/src/environments/environment';
import { MatTabChangeEvent } from '@angular/material';
import { LogicService } from '../../../services/logic.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeDetailsComponent implements OnInit, OnDestroy {

  displayedColumns = ['date', 'amount'];
  currentEmployee: Employee;
  contentLocation: AppState = new AppState();
  //////////////////////////////////////
  principalSubscription: Subscription;
  parameterSubscription: Subscription;
  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  retirementSavingParameter: Parameter | null = null;
  permanentLoanParameter: Parameter | null = null;
  retirementLoanParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;
  longFundParameter: FundParameters | null = null;
  //////////////////////////////////////
  permanentSavingDisabledReason = '';
  permanentSavingLoanDisabledReason = '';
  retirementSavingLoanDisabledReason = '';

  hideShortFund = true;

  caja: string;
  fondo: string;
  general: string;
  laboral: string;
  prestamos: string;

  cajaIcon: string;
  fondoIcon: string;
  generalIcon: string;
  laboralIcon: string;
  prestamosIcon: string;
  payrollContributions: Array<Income>;

  employeeInfo = '';
  employeeNumber: string;
  shareSavingsHide: false;
  shareSavingsParameters: any;
  shareSavingsDisabled: boolean;

  constructor(public logicService: LogicService, private route: ActivatedRoute, private authService: AuthenticationService, private dataService: DataSourceService) {

    this.caja = environment.images.states.selected.caja;
    this.fondo = environment.images.states.unselected.fondo;
    this.general = environment.images.states.unselected.general;
    this.laboral = environment.images.states.unselected.laboral;
    this.prestamos = environment.images.states.unselected.prestamos;

    this.cajaIcon = environment.images.states.normal.caja;
    this.fondoIcon = environment.images.states.normal.fondo;
    this.generalIcon = environment.images.states.normal.general;
    this.laboralIcon = environment.images.states.normal.laboral;
    this.prestamosIcon = environment.images.states.normal.prestamos;

    this.principalSubscription = this.logicService.dataManager.proxyDataLoader.changes.subscribe(d => {

      if (d && d.response) {
        this.currentEmployee = d.response;
        const employeeInfoToShow = d && d.response ? 'Colaborador ' + d.response.workInformation.employeeNumber + ' - ' + d.response.displayName : 'Cargando Información ...';
        this.employeeInfo = employeeInfoToShow;
        this.hideShortFund = d && d.response && d.response.funds.find(e => e.type === 'FAC') ? false : true;

        const values = this.currentEmployee.workInformation.wage.historical.values();
        values.sort((a, b) => b.date.getTime() - a.date.getTime());
        this.payrollContributions = new Array<Income>();

        values.slice(0, 4).forEach(v => {
          // Your time zone set 00:00 -6 or -5
          const aUTCMoment = moment(Number(v.payrollID)).add(7, 'hours');

          if (aUTCMoment.hour() === 0) {
            console.log(aUTCMoment.valueOf(), aUTCMoment.toDate());
          }

          v.date = aUTCMoment.toDate();
          this.payrollContributions.push(v);

        });

        this.procData();
        this.shouldHideShareSavings();


      }

    });

    this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

      if (p && p.response) {
        this.procData();
      }

    });

    this.employeeNumber = this.route.snapshot.paramMap.get('id');
    this.logicService.dataManager.proxyDataLoader.loadEmployeeFromDataSource(this.employeeNumber);
    this.logicService.dataManager.generalDataLoader.load();
    this.logicService.dataManager.parameterDataLoader.load();


  }

  procData() {

    if (!this.currentEmployee || !this.logicService.dataManager.parameterDataLoader.parameters) {
      return;
    }

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters;
    const fundParameters = this.logicService.dataManager.parameterDataLoader.fundParameters;

    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.permanentLoanParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.retirementLoanParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.shortFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.shortSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));
    this.longFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.longSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));

  }

  ngOnInit() {

  }

  ngOnDestroy(): void {

    if (this.principalSubscription && !this.principalSubscription.closed) {
      this.principalSubscription.unsubscribe();
      this.principalSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }


  }

  get activeStatusPermanentSavings(): boolean {
    // ahorro en 0 no se muestra
    if (this.currentEmployee.permanentSavings) {

      return true;


    } else {
      return false;

    }
  }

  ////////////////////////////////////////////////

  get shouldDisablePermanentSavingButton(): boolean {
    // poder inscribirse administradores
    if (this.authService.appLevel.administrator) {
      return false;
    }

    if (!this.permanentSavingParameter) {
      this.permanentSavingDisabledReason = 'No es posible registrarse ya que se esta fuera de periodo.';
      return true;
    }

    if (!this.permanentSavingParameter.isRegistrationDateAllowed) {
      this.permanentSavingDisabledReason = 'En este momento no es posible la reinscripción ya que esta fuera del periodo.';
      return true;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
      this.permanentSavingDisabledReason = 'En este momento no es posible registrarse ya que estamos dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (this.currentEmployee.permanentSavings) {
      return false;
    }

    return false;

  }

  get shouldDisablePermanentLoanButton(): boolean {

    if (this.currentEmployee.permanentSavingsLoan !== null) {
      return false;
    }

    if (!this.permanentLoanParameter) {
      this.permanentSavingLoanDisabledReason = 'No es posible solicitar un préstamo ya que se esta fuera del periodo.';
      return false;
    }

    if (!this.permanentLoanParameter.applicableLoanParameter) {
      this.permanentSavingLoanDisabledReason = 'No es posible solicitar un préstamo ya que no se ha especificado el siguiente periodo.';
      return true;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
      this.permanentSavingLoanDisabledReason = 'En este momento no es posible solicitar un préstamo ya que se esta dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (!this.permanentLoanParameter.isLoanDateAllowed) {
      this.permanentSavingLoanDisabledReason = 'No es posible solicitar un préstamo ya que no hay un ciclo activo.';

      return true;

    }

    return false;

  }

  ////////////////////////////////////////////////

  get shouldHideRetirementSavings(): boolean {

    return this.currentEmployee.retirementSavingsData === null || this.currentEmployee.retirementSavingsData.length === 0;

  }

  get shouldHideRetirementLoan(): boolean {

    if (this.retirementLoanParameter) {

      if (this.currentEmployee.workInformation.wage.wageName.toUpperCase() === 'CATORCENAL') {

        return this.currentEmployee.retirementSavingsData === null || this.currentEmployee.retirementSavingsData.length === 0;

      }

    }

    return true;

  }

  get shouldDisableRetirementLoanButton(): boolean {


    if (this.currentEmployee.retirementSavingsLoan) {
      return false;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
      this.retirementSavingLoanDisabledReason = 'En este momento no es posible solicitar un préstamo ya que se esta dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (!this.retirementLoanParameter) {
      this.retirementSavingLoanDisabledReason = 'No es posible solicitar un préstamo a la caja de ahorro de retiro.';
      return true;
    } else {
      return false;
    }

  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  shouldHideShareSavings() {
    this.logicService.activeShareSavings(this.currentEmployee).then(async (r) => {
      this.shareSavingsParameters = r;
      this.shareSavingsHide = r.visible;

      const shareSavingsData = await this.dataService.shareSavingsUser(this.currentEmployee.uid);

      const shareSavingsRegister = shareSavingsData ? shareSavingsData.docs.map(x => x.data()) : [];

      if (!r.habilitado && shareSavingsRegister.length === 0) {
        this.shareSavingsDisabled = true;

      } else {  
        this.shareSavingsDisabled = false;

      }


    }).catch(error => console.log(error));


  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  get shouldDisableShortFund(): boolean {

    if (!this.shortFundParameter) {
      return true;
    }

    return false;

  }

  get shouldDisableLongFund(): boolean {

    if (!this.longFundParameter) {
      return true;
    }

    return false;

  }

  ////////////////////////////////////////////////

  tabChanged(event: MatTabChangeEvent): void {

    this.contentLocation.tabIndex = event.index;
    this.contentLocation.detailIndex = 0;
    this.contentLocation.contentIndex = 0;
    this.contentLocation.savingParametersIndex = 0;

    this.caja = environment.images.states.unselected.caja;
    this.fondo = environment.images.states.unselected.fondo;
    this.general = environment.images.states.unselected.general;
    this.laboral = environment.images.states.unselected.laboral;
    this.prestamos = environment.images.states.unselected.prestamos;

    if (event.index === 0) {
      this.caja = environment.images.states.selected.caja;
    } else if (event.index === 1) {
      this.prestamos = environment.images.states.selected.prestamos;
    } else if (event.index === 2) {
      this.fondo = environment.images.states.selected.fondo;
    } else if (event.index === 3) {
      this.general = environment.images.states.selected.general;
    } else if (event.index === 4) {
      this.laboral = environment.images.states.selected.laboral;
    }

  }

  subTabChangeSavings(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex === 0) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

  subTabChangeLoans(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex === 1) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

  subTabChangeFunds(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex > 1) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

}
